export function getdata() {
	var obj = {
		searchlist: [{
				prop: "danjh",
				label: '单据号',
				type: "input"
			}, {
				prop: "faphm",
				label: '发票号码',
				type: "input",
				isNumber: true
			}, {
				prop: "tedywlx",
				label: '特殊业务',
				type: "select",
				selectval: [{
						label: "成品油",
						value: "01"
					},
					{
						label: "稀土",
						value: "02"
					},
					{
						label: "建筑服务",
						value: "03"
					},
					{
						label: "不动产经营租赁",
						value: "06"
					},
					{
						label: "机动车",
						value: "13"
					},
				]
			},
			{
				prop: "danjly",
				label: '单据来源',
				type: "select",
				selectval: [{
						value: '1',
						label: '文件导入'
					},
					{
						value: '2',
						label: '手工录入'
					},
					{
						value: '3',
						label: '客户接口'
					},
					{
						value: '6',
						label: '扫码开票'
					},
					{
						value: '7',
						label: '红冲重开'
					},
					{
						value: '8',
						label: '作废重开'
					},
				]
			},
			{
				prop: "danjrq",
				label: '单据日期',
				type: "date",
				valueformat: "yyyyMMdd"
			}, {
				prop: "jiashj",
				label: '价税合计',
				type: "input",
				isNumber: true
			}, {
				prop: "jine",
				label: '金额',
				type: "input",
				isNumber: true
			}, {
				prop: "shuie",
				label: '税额',
				type: "input",
				isNumber: true
			}, {
				prop: "kaiprq",
				label: '开票日期',
				type: "date",
				valueformat: "yyyyMMdd"
			},
			{
				prop: "goufmc",
				label: '购方名称',
				type: "input"
			},
		],
		searchdata: {
			"danjh": "",
			"faphm": "",
			"tedywlx": "",
			"danjzt": "1",
			"danjly": "",
			"jiashj": "",
			"shuie": "",
			"jine": "",
			"goufmc": "",
			"danjrq": [],
			"kaiprq": []
		},
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
		headData: [{
				title: "单据号",
				prop: "danjh",
				width: "100",
				issort: true
			},
			{
				title: "单据状态",
				prop: "fapzt",
				width: "80",
				custom: true,
				issort: true
			}, {
				title: "发票来源",
				prop: "faply",
				width: "80",
				custom: true,
				issort: true
			}, {
				title: "发票类型",
				prop: "faplxdm",
				width: "80",
				custom: true,
				issort: true
			},
			{
				title: "特殊业务",
				prop: "tedywlx",
				width: "80",
				custom: true,
				issort: true
			},
			{
				title: "购方名称",
				prop: "goufmc",
				width: "160",
				align: "left",
				issort: true
			},
			{
				title: "金额",
				prop: "hejje",
				width: "80",
				align: "right",
				AmountFormat: true,
				issort: true
			},
			{
				title: "税额",
				prop: "hejse",
				width: "80",
				align: "right",
				AmountFormat: true,
				issort: true
			},
			{
				title: "单据日期",
				prop: "danjrq",
				width: "100"
			},

		],
	}
	return obj
}
